import { useEffect, useRef, type KeyboardEvent } from 'react'
import { Search } from 'lucide-react'

interface MenuSearchProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
}

export function MenuSearch({ value, onChange, placeholder }: MenuSearchProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const frame = requestAnimationFrame(() => inputRef.current?.focus())
    return () => cancelAnimationFrame(frame)
  }, [])

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key.length === 1) event.stopPropagation()
    if (event.key !== 'ArrowDown') return
    event.preventDefault()
    const input = event.currentTarget
    const items = input.closest('[data-radix-menu-content]')?.querySelectorAll<HTMLElement>('[role="menuitem"]:not([data-disabled])') ?? []
    const firstResult = Array.from(items).find(item => input.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING)
    firstResult?.focus()
  }

  return (
    <div className="-mx-1 mb-1 flex items-center gap-2 border-b border-border px-3 pb-1.5">
      <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
      <input
        ref={inputRef}
        value={value}
        onChange={event => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className="h-8 w-full bg-transparent text-base outline-none sm:text-sm placeholder:text-muted-foreground"
      />
    </div>
  )
}
